import { TextFieldProps } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import { FC, memo } from 'react'
import { StyledTextField, CharacterCountWrapper } from './textFieldV2.styles'

export type TextFieldV2Props = TextFieldProps & {
  maxLength?: number
}

const TextFieldV2: FC<TextFieldV2Props> = ({ variant = 'outlined', maxLength, value, ...props }) => {
  const currentLength = typeof value === 'string' ? value.length : 0

  return (
    <FormControl fullWidth>
      <StyledTextField
        variant={variant}
        value={value}
        inputProps={{
          ...props.inputProps,
          maxLength: maxLength
        }}
        {...props}
      />
      {maxLength && (
        <CharacterCountWrapper>
          {currentLength}/{maxLength}
        </CharacterCountWrapper>
      )}
    </FormControl>
  )
}

export default memo(TextFieldV2)
